module.exports = __webpack_public_path__ + "img/logo_vo_document.72dfbd2a.png";